<template>
  <div class="portefeuille-section portefeuille-module portefeuille-beneficiaries-module">
    <v-container class="section-content">
      <button class="back-button" @click="goBack">
        <span class="fa fa-arrow-left"></span> {{ $t('common.back') }}
      </button>

      <div class="page-header">
        <div class="header-content">
          <h1 class="page-title">{{ $t('portefeuille.beneficiaries') }}</h1>
          <p class="page-subtitle">{{ $t('portefeuille.beneficiaries_subtitle') }}</p>
        </div>
      </div>

      <div class="toolbar-section">
        <div class="search-box">
          <span class="fa fa-search search-icon"></span>
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="$t('portefeuille.search_beneficiary')"
            class="search-input"
          />
        </div>
        <button class="add-button" @click="openAddDialog">
          <span class="fa fa-plus"></span> {{ $t('common.add') }}
        </button>
      </div>

      <div v-if="loading" class="empty-state">
        <span class="fa fa-spinner fa-spin empty-icon"></span>
        <p class="empty-text">{{ $t('common.loading') }}</p>
      </div>

      <div v-else-if="filteredBeneficiaries.length === 0" class="empty-state">
        <span class="fa fa-users empty-icon"></span>
        <p class="empty-text">{{ $t('portefeuille.no_beneficiaries') }}</p>
      </div>

      <div v-else class="table-wrapper">
        <table class="beneficiaries-table">
          <thead>
            <tr>
              <th>{{ $t('portefeuille.beneficiary') }}</th>
              <th>{{ $t('portefeuille.beneficiary_gender') }}</th>
              <th>{{ $t('portefeuille.beneficiary_phone') }}</th>
              <th>{{ $t('portefeuille.beneficiary_cni') }}</th>
              <th>{{ $t('common.action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="beneficiary in filteredBeneficiaries" :key="beneficiary._id" class="table-row">
              <td class="beneficiary-cell">
                <span class="beneficiary-icon fa fa-user"></span>
                <div class="beneficiary-info">
                  <div class="beneficiary-name">{{ beneficiary.prenom }} {{ beneficiary.nom }}</div>
                  <div class="beneficiary-details">{{ displayGenre(beneficiary.genre) }} · CNI: {{ beneficiary.numero_cni }}</div>
                </div>
              </td>
              <td>{{ displayGenre(beneficiary.genre) }}</td>
              <td>{{ beneficiary.telephone }}</td>
              <td>{{ beneficiary.numero_cni }}</td>
              <td class="action-cell">
                <div class="action-buttons">
                  <button class="action-btn" @click="editBeneficiary(beneficiary)" title="Modifier">
                    <span class="fa fa-edit"></span>
                  </button>
                  <button class="action-btn" @click.stop="requestDeleteBeneficiary(beneficiary._id)" title="Supprimer">
                    <span class="fa fa-trash"></span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-container>

    <v-dialog v-model="itemDialog" max-width="600" persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-neutral">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields">
                <div class="field-title font-weight-bold">
                  {{ editingItem ? $t('portefeuille.edit_beneficiary') : $t('portefeuille.add_beneficiary') }}
                </div>
                <div class="row">
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_first_name') }} <span style="color: #e74c3c;">*</span></label><input v-model="formData.prenom" type="text" class="field-input" /></div></div>
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_last_name') }} <span style="color: #e74c3c;">*</span></label><input v-model="formData.nom" type="text" class="field-input" /></div></div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">{{ $t('portefeuille.beneficiary_gender') }} <span style="color: #e74c3c;">*</span></label>
                      <v-autocomplete
                        v-model="formData.genre"
                        :items="genderOptions"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined
                        clearable
                        :placeholder="$t('common.select')"
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="field-group field-default">
                      <label class="field-label">{{ $t('portefeuille.beneficiary_country') }} <span style="color: #e74c3c;">*</span></label>
                      <v-autocomplete
                        v-model="formData.pays"
                        :items="countriesList"
                        dense
                        outlined
                        clearable
                        :placeholder="$t('common.select')"
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_address') }}</label><input v-model="formData.adresse" type="text" class="field-input" /></div></div>
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_phone') }}</label><input v-model="formData.telephone" maxlength="9" type="text" class="field-input" @keypress="onlyNumber" /></div></div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_cni') }}</label><input v-model="formData.numero_cni" type="text" class="field-input" @keypress="onlyNumber" /></div></div>
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_birth_date') }}</label><input v-model="formData.datenaissance" type="date" class="field-input" /></div></div>
                </div>
                <div class="row mt-3">
                  <div class="col-sm-6"><div class="field-group field-default"><label class="field-label">{{ $t('portefeuille.beneficiary_cmu') }}</label><input v-model="formData.cmu" type="text" class="field-input" /></div></div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="itemDialog = false">{{ $t('common.cancel') }}</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="saveBeneficiary">{{ $t('common.save') }}</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="460" persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-neutral">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields text-center">
                <div class="field-title font-weight-bold">Supprimer</div>
                <div class="field-sub-title">{{ $t('common.confirm_delete', 'Êtes-vous sûr ?') }}</div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="cancelDeleteBeneficiary">{{ $t('common.cancel') }}</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="confirmDeleteBeneficiary">{{ $t('common.delete') }}</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Api from '../../../services/Api'

export default {
  name: 'PortefeuilleBeneficiaries',
  data() {
    return {
      searchQuery: '',
      itemDialog: false,
      deleteDialog: false,
      pendingDeleteId: null,
      editingItem: null,
      countries: [],
      formData: {
        nom: '',
        prenom: '',
        genre: '',
        pays: '',
        adresse: '',
        telephone: '',
        numero_cni: '',
        datenaissance: '',
        cmu: ''
      }
    }
  },
  computed: {
    ...mapState('beneficiaries', ['loading']),
    ...mapGetters('beneficiaries', ['listeBeneficiaries']),
    filteredBeneficiaries() {
      if (!this.searchQuery) return this.listeBeneficiaries
      const query = this.searchQuery.toLowerCase()
      return this.listeBeneficiaries.filter(beneficiary =>
        String(beneficiary.nom || '').toLowerCase().includes(query) ||
        String(beneficiary.prenom || '').toLowerCase().includes(query) ||
        String(beneficiary.telephone || '').toLowerCase().includes(query)
      )
    },
    genderOptions() {
      return [
        { label: this.$t('portefeuille.beneficiary_gender_adult_male'), value: 'Adulte_homme' },
        { label: this.$t('portefeuille.beneficiary_gender_adult_female'), value: 'Adulte_femme' },
        { label: this.$t('portefeuille.beneficiary_gender_boy'), value: 'garcon' },
        { label: this.$t('portefeuille.beneficiary_gender_girl'), value: 'fille' },
        { label: this.$t('portefeuille.beneficiary_gender_senior_male'), value: 'homme' },
        { label: this.$t('portefeuille.beneficiary_gender_senior_female'), value: 'femme' }
      ]
    },
    countriesList() {
      return this.countries.map(c => c.PAYS)
    }
  },
  methods: {
    ...mapActions('beneficiaries', [
      'fetchBeneficiaries',
      'addBeneficiary',
      'updateBeneficiary',
      'deleteBeneficiary'
    ]),

    showError(message) {
      // Fermer tous les toasts existants avant d'afficher un nouveau
      this.$toasted.clear()
      this.$toasted.show(message, {
        theme: 'toasted-primary',
        position: 'top-center',
        type: 'error',
        duration: 3000,
        singleton: true
      })
    },

    normalizeGenre(value) {
      if (!value) return ''
      // Retourner la valeur telle quelle (elle provient du SELECT avec les 6 catégories)
      return value
    },

    displayGenre(value) {
      return this.normalizeGenre(value)
    },

    onlyNumber(event) {
      const code = event.which || event.keyCode
      if (code < 48 || code > 57) {
        event.preventDefault()
      }
    },

    getListePays() {
      Api()
        .get('/pays/all')
        .then((response) => {
          this.countries = response.data
        })
        .catch((error) => {
          console.error('Erreur lors du chargement des pays:', error)
        })
    },

    async loadBeneficiaries() {
      try {
        await this.fetchBeneficiaries()
      } catch (error) {
        this.$toasted.show(this.$t('common.error_loading', 'Erreur de chargement'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      }
    },

    openAddDialog() {
      this.editingItem = null
      this.formData = {
        nom: '',
        prenom: '',
        genre: '',
        pays: '',
        adresse: '',
        telephone: '',
        numero_cni: '',
        datenaissance: '',
        cmu: ''
      }
      this.itemDialog = true
    },

    editBeneficiary(beneficiary) {
      this.editingItem = beneficiary
      this.formData = {
        nom: beneficiary.nom || '',
        prenom: beneficiary.prenom || '',
        genre: this.normalizeGenre(beneficiary.genre),
        pays: beneficiary.pays || '',
        adresse: beneficiary.adresse || '',
        telephone: beneficiary.telephone || '',
        numero_cni: beneficiary.numero_cni || '',
        datenaissance: beneficiary.datenaissance || '',
        cmu: beneficiary.cmu || ''
      }
      this.itemDialog = true
    },

    requestDeleteBeneficiary(id) {
      this.pendingDeleteId = id
      this.deleteDialog = true
    },

    cancelDeleteBeneficiary() {
      this.pendingDeleteId = null
      this.deleteDialog = false
    },

    async confirmDeleteBeneficiary() {
      if (!this.pendingDeleteId) return

      try {
        await this.deleteBeneficiary(this.pendingDeleteId)
        this.$toasted.show(this.$t('common.deleted', 'Supprimé avec succès'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } catch (error) {
        this.$toasted.show(this.$t('common.error_delete', 'Erreur de suppression'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } finally {
        this.cancelDeleteBeneficiary()
      }
    },

    async saveBeneficiary() {
      // Validation des champs obligatoires
      if (!this.formData.prenom) {
        this.showError(this.$t('portefeuille.beneficiary_first_name_required'))
        return
      }
      if (!this.formData.nom) {
        this.showError(this.$t('portefeuille.beneficiary_last_name_required'))
        return
      }
      if (!this.formData.genre) {
        this.showError(this.$t('portefeuille.beneficiary_gender_required'))
        return
      }
      if (!this.formData.pays) {
        this.showError(this.$t('portefeuille.beneficiary_country_required'))
        return
      }

      try {
        const beneficiaryData = {
          ...this.formData,
          genre: this.normalizeGenre(this.formData.genre)
        }

        if (this.editingItem) {
          await this.updateBeneficiary({
            id: this.editingItem._id,
            beneficiaryData
          })
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.updated'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        } else {
          await this.addBeneficiary(beneficiaryData)
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.saved'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        }
        this.itemDialog = false
      } catch (error) {
        this.showError(this.$t('common.error_saving'))
      }
    },

    goBack() {
      this.$router.push({ name: 'portefeuille' })
    }
  },

  mounted() {
    this.loadBeneficiaries()
    this.getListePays()
  }
}
</script>

<style scoped>
.portefeuille-section {
  padding: 2rem;
  padding-top: 100px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.portefeuille-modal-accent-neutral {
  --custom-color-primary: #ffa409;
}

.section-header {
  margin-bottom: 1.5rem;
}

.page-header {
  margin-bottom: 1.5rem;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 3.2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.page-subtitle {
  font-size: 1.4rem;
  color: #666;
  margin: 0;
}

.back-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: #333;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
  margin-bottom: 1rem;
}

.back-button:hover {
  color: #ffa409;
}

.section-title {
  flex: 1;
  font-size: 1.75rem;
  font-weight: 700;
  color: #000;
  margin: 0;
  font-family: 'Lato', sans-serif;
}

.add-button {
  background: #ffa409;
  border: none;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
}

.toolbar-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 1rem;
}

.search-box {
  flex: 1;
  position: relative;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
}

.search-icon {
  color: #999;
  margin-right: 0.8rem;
  font-size: 0.875rem;
}

.search-input {
  border: none;
  outline: none;
  flex: 1;
  font-size: 1rem;
  color: #333;
  background: transparent;
  font-family: 'Lato', sans-serif;
}

.search-input::placeholder {
  color: #999;
}

.add-button:hover {
  background: #ff9500;
  box-shadow: 0 4px 12px rgba(255, 164, 9, 0.3);
}

.section-content {
  /* Vuetify v-container padding par defaut */
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  background: white;
  border-radius: 8px;
}

.empty-icon {
  font-size: 4rem;
  color: #ddd;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1.1rem;
  color: #999;
  margin: 0;
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.beneficiaries-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.15rem;
}

.beneficiaries-table thead {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.beneficiaries-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.beneficiaries-table th:last-child {
  text-align: right;
}

.table-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #fafafa;
}

.table-row td {
  padding: 1rem;
  color: #333;
}

.beneficiary-cell {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.beneficiary-icon {
  font-size: 1.5rem;
  color: #ffa409;
}

.beneficiary-info {
  display: flex;
  flex-direction: column;
}

.beneficiary-name {
  font-weight: 600;
  color: #1a1a1a;
}

.beneficiary-details {
  font-size: 0.85rem;
  color: #999;
}

.action-cell {
  text-align: right;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.action-btn {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #f0f0f0;
  color: #ffa409;
}

.input-field {
  margin-bottom: 1rem;
}

.field-autocomplete {
  margin-top: 0.5rem;
}

.field-autocomplete >>> .v-input__control {
  min-height: 45px;
}

.field-autocomplete >>> .v-text-field__details {
  display: none;
}

@media only screen and (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .back-button,
  .add-button {
    justify-content: center;
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .section-subtitle,
  .page-subtitle {
    font-size: 1rem;
  }

  .portefeuille-section {
    padding: 1rem;
    padding-top: 80px;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .beneficiaries-table {
    font-size: 0.95rem;
  }

  .beneficiaries-table th {
    font-size: 0.85rem;
  }

  .beneficiaries-table th,
  .beneficiaries-table td {
    padding: 0.75rem 0.5rem;
  }

  .empty-text {
    font-size: 1rem;
  }
}
</style>
